import React from "react";

const scrollToForm = (e) => {
  e.preventDefault();
  const el = document.getElementById("lead-form");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function FooterCTA() {
  return (
    <section
      data-testid="footer-cta-section"
      className="text-white py-20 md:py-24 relative overflow-hidden bg-[#003242]"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[#88d2e7]/10 blur-3xl pointer-events-none" />

      <div className="met-container relative text-center">
        <h2
          data-testid="footer-cta-title"
          className="text-3xl md:text-4xl lg:text-5xl font-black tracking-tighter leading-[1.05] max-w-4xl mx-auto text-balance"
        >
          Votre contrat travaille pour vous - <span className="text-[#88d2e7]">ou contre vous.</span>
        </h2>
        <p
          data-testid="footer-cta-sub"
          className="mt-6 text-white/75 text-base md:text-lg font-medium max-w-2xl mx-auto"
        >
          {`5 minutes pour le savoir. L'audit est gratuit.`}
        </p>
        <button
          type="button"
          onClick={scrollToForm}
          data-testid="footer-cta-button"
          className="group mt-10 inline-flex items-center gap-2 bg-white text-[#005870] hover:bg-[#88d2e7] hover:text-[#003242] font-bold text-base md:text-lg px-9 py-5 rounded-full transition-colors duration-300"
        >
          Demander mon audit
          <svg className="transition-transform group-hover:translate-x-1" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M13 6l6 6-6 6"/>
          </svg>
        </button>
      </div>
    </section>
  );
}
